import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { AuthenticationService } from './../../core/authentication/authentication.service';
import { Logger } from './../../core/logger.service';
import { UserService } from 'app/core/user/user.service';
import { ModalService } from 'app/modal/modal.service';
import * as Models from 'app/core/models';
import { ILoginResult } from './loginResult.model';
import { LoginAction } from './loginAction.enum';
import {TranslateService} from '@ngx-translate/core';

const log = new Logger('App');
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent {

  @Input('inModal') inModal = false;
  @Output('successHandler') successHandler: EventEmitter<ILoginResult> = new EventEmitter<ILoginResult>();
  @Output('failiureHandler') failiureHandler: EventEmitter<ILoginResult> = new EventEmitter<ILoginResult>();
  @Output('cancelHandler') cancelHandler: EventEmitter<ILoginResult> = new EventEmitter<ILoginResult>();

  version: string = environment.version;
  error: any = null;
  loginForm: FormGroup;
  isLoading = false;

  constructor(private formBuilder: FormBuilder,
              private authenticationService: AuthenticationService,
              private userService: UserService,
              private modalService: ModalService,
              private translateService: TranslateService) {
    this.createForm();
  }

  login() {
    this.isLoading = true;
    this.authenticationService.login(this.loginForm.value)
      .finally(() => {
        if (!this.error) {
          this.getUserDetails();
        } else {
          this.isLoading = false;
        }
      })
      .subscribe(credentials => {
        log.debug(`successfully logged in`);
        this.error = null;
        this.authenticationService.setCredentials(credentials, true);
      }, error => {
        log.debug(`Login error: ${error}`);
        this.error = error;
        this.failiureAction();
      });
  }

  sucessAction() {
    this.successHandler.next({ action: LoginAction.POSITIVE });
  }

  failiureAction() {
    this.failiureHandler.next({
      action: LoginAction.NEGETIVE
    });
  }

  forgotPassword() {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.FORGOT_PASSWORD,
      modalAction: Models.ModalAction.OPEN,
      parameters: []
    };
    this.modalService.command(data);
  }

  signUp() {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.SIGN_UP,
      modalAction: Models.ModalAction.OPEN,
      parameters: []
    };
    this.modalService.command(data);
  }

  private getUserDetails() {
    this.userService.getUserDetails()
      .finally(() => {
        if (!this.error) {
          this.loginForm.markAsPristine();
          this.loginForm.reset();
          this.sucessAction();
        }
        this.isLoading = false;
      })
      .subscribe(userDetails => {
        log.debug(`successfully Got UserDetails`);
        this.error = null;
        this.userService.setUserDetails(userDetails);
      }, error => {
        log.debug(`GetUserDetails error: ${error}`);
        this.error = error;
        this.authenticationService.setCredentials();
        this.failiureAction();
      });
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.email],
      password: ['', Validators.required]
    });
  }

  get errorMessage(): string {
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    }
    this.translateService.get('AUTH.LOGIN.GENERAL_ERROR').subscribe((translatedErrMsg: string) => {
      return translatedErrMsg
    });
  }

}





// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/login/login.component.ts